import type { RouteRecordRaw } from 'vue-router';

const H5Layout = () => import('@/h5/layouts/H5Layout.vue');

export const h5Routes: RouteRecordRaw[] = [
  {
    path: '/h5',
    component: H5Layout,
    children: [
      {
        path: '',
        name: 'h5-home',
        component: () => import('@/h5/views/home/Home.vue'),
        meta: { h5Public: true, title: '首页' },
      },
      {
        path: 'vehicles',
        name: 'h5-vehicle-list',
        component: () => import('@/h5/views/vehicle/VehicleList.vue'),
        meta: { h5Public: true, title: '车源' },
      },
      {
        path: 'vehicles/:uuid',
        name: 'h5-vehicle-detail',
        component: () => import('@/h5/views/vehicle/VehicleDetail.vue'),
        meta: { h5Public: true, title: '车辆详情' },
      },
      {
        path: 'estimate',
        name: 'h5-estimate',
        component: () => import('@/h5/views/estimate/Estimate.vue'),
        meta: { h5Public: true, title: '在线估价' },
      },
      {
        path: 'compare',
        name: 'h5-compare',
        component: () => import('@/h5/views/compare/Compare.vue'),
        meta: { title: '对比' },
      },
      {
        path: 'appointment/:vehicleUuid',
        name: 'h5-appointment',
        component: () => import('@/h5/views/appointment/Appointment.vue'),
        meta: { title: '预约看车' },
      },
      {
        path: 'sell',
        name: 'h5-sell',
        component: () => import('@/h5/views/sell/Sell.vue'),
        meta: { h5Public: true, title: '我要卖车' },
      },
      {
        path: 'coupons',
        name: 'h5-coupon-list',
        component: () => import('@/h5/views/coupon/CouponList.vue'),
        meta: { h5Public: true, title: '优惠券' },
      },
      {
        path: 'activities',
        name: 'h5-activity-list',
        component: () => import('@/h5/views/activity/ActivityList.vue'),
        meta: { h5Public: true, title: '活动' },
      },
      {
        path: 'activities/:id',
        name: 'h5-activity-detail',
        component: () => import('@/h5/views/activity/ActivityDetail.vue'),
        meta: { h5Public: true, title: '活动详情' },
      },
      {
        path: 'user',
        name: 'h5-user',
        component: () => import('@/h5/views/user/UserCenter.vue'),
        meta: { title: '我的' },
      },
      {
        path: 'user/favorites',
        name: 'h5-user-favorites',
        component: () => import('@/h5/views/user/Favorites.vue'),
        meta: { title: '我的收藏' },
      },
      {
        path: 'user/appointments',
        name: 'h5-user-appointments',
        component: () => import('@/h5/views/user/Appointments.vue'),
        meta: { title: '我的预约' },
      },
      {
        path: 'user/coupon',
        name: 'h5-user-coupon',
        component: () => import('@/h5/views/user/MyCoupon.vue'),
        meta: { title: '我的优惠券' },
      },
      {
        path: 'user/orders',
        name: 'h5-user-orders',
        component: () => import('@/h5/views/user/Orders.vue'),
        meta: { title: '我的订单' },
      },
      {
        path: 'wechat-bind',
        name: 'h5-wechat-bind',
        component: () => import('@/h5/views/wechat/WechatBind.vue'),
        meta: { h5Public: true, title: '微信绑定' },
      },
      {
        path: 'select-org',
        name: 'h5-select-org',
        component: () => import('@/h5/views/org/SelectOrg.vue'),
        meta: { h5Public: true, title: '选择机构' },
      },
    ],
  },
];
